import { render, staticRenderFns } from "./physical.vue?vue&type=template&id=b1a977b0&scoped=true"
import script from "./physical.vue?vue&type=script&lang=js"
export * from "./physical.vue?vue&type=script&lang=js"
import style0 from "./physical.vue?vue&type=style&index=0&id=b1a977b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a977b0",
  null
  
)

export default component.exports